// 弹出的天展主体dom渲染
import { setAttributes } from './attribute.js' 
const iframeRender = () => {
    const iframeWrap = document.createElement('div')
    iframeWrap.className = 'tz-iframe-wrap'
    const iframeTitleWrap = document.createElement('section')
    iframeTitleWrap.className = 'title-wrap'
    const iframeTitle = document.createElement('span')
    const iframeClose = document.createElement('span')
    iframeClose.className = 'close-icon'
    const iframeMask = document.createElement('div')
    iframeMask.className = 'mask'
    
    iframeTitle.innerHTML = '天天展位'
    iframeClose.innerHTML = '+'
    iframeTitleWrap.appendChild(iframeTitle)
    iframeTitleWrap.appendChild(iframeClose)
    iframeWrap.appendChild(iframeTitleWrap)

    iframeClose.onclick = () => {
        document.getElementById('commercial').removeChild(iframeWrap)
        document.getElementById('commercial').removeChild(iframeMask)
    }

    const iframeContent = document.createElement('iframe')
    setAttributes(iframeContent, {
        style: 'width: 100%; height: calc(100% - 40px)',
        frameborder: '0',
        class: 'tz-iframe',
        src: `//legohyapi.58.com/pc/infotop/ttzhanwei?entityType=0&entityId=${window.commercial.entityidlist}&productId=10090&source=9080100`
    })
    iframeWrap.appendChild(iframeContent)
    document.getElementById('commercial').appendChild(iframeWrap)
    document.getElementById('commercial').appendChild(iframeMask)
}
export default iframeRender